<template>
    <div>
        <header class="pb-3">
            <b-container>
                <b-row>
                    <b-col>
                        <router-link to="/"><img src="@/assets/thepaymentoption-logo-white.svg" class="logo mt-4"/></router-link>
                    </b-col>
                    <b-col class="text-right pt-5" sm="12" md="9">
                        <ul class="menu">
                            <router-link tag="li" exact-active-class="active" :to="{name: 'accounts', params: {code}}">
                                <i class="fas fa-credit-card mr-2"></i>Accounts
                            </router-link>
                            <router-link tag="li" exact-active-class="active" :to="{name: 'messages', params: {code}}">
                                <i class="fas fa-messages mr-2"></i>Messages <span class="message-count" v-if="messageCount">({{ messageCount }})</span>
                            </router-link>
                            <li class="active"><i class="fas fa-user mr-2"></i>Profile</li>
                            <li @click="sessionLogout"><i class="fas fa-sign-out mr-2"></i>Logout</li>
                        </ul>
                    </b-col>
                </b-row>
            </b-container>
        </header>

        <b-container class="mt-5 pb-5 mb-5">
            <b-row>
                <b-col lg="10" xl="8">
                    <contact-info :code="code"/>
                </b-col>
            </b-row>
        </b-container>

        <footer class="pt-3 pb-2">
            <b-container>
                <copyright class="mt-3 mb-3"/>
            </b-container>
        </footer>
    </div>
</template>

<script>
    import Copyright from "../components/Copyright";
    import ContactInfo from "../components/ContactInfo";
    import {mapActions} from "vuex";

    export default {
        name: "Profile",
        components: {Copyright, ContactInfo},
        props: ['code'],
        data: function() {
            return {
                messageCount: 0
            };
        },
        methods: {
            ...mapActions(['getMessages', 'logout']),
            sessionLogout: function() {
                this.logout(this.code).then(() => {
                    console.log('Session destroyed.');
                });
                this.$router.push({name: 'home'});
            }
        },
        mounted: function() {
            this.getMessages(this.code).then(messages => {
                this.messageCount = messages.length;
            }, err => {
                console.error(err);
            });
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    header {
        .logo {
            max-width: 160px;
        }

        background: #3c3c5f;
        color: white;

        .menu {
            list-style: none;

            li {
                display: inline-block;
                margin-left: 1rem;
                padding: 0.2rem 1rem;
                border-radius: 1.5rem;
                cursor: pointer;

                &:hover {
                    background-color: rgba(255, 255, 255, 0.15);
                }

                &.active {
                    background-color: white !important;
                    color: #3c3c5f;
                }

                @media only screen and (max-width: 600px) {
                    padding: 0.5rem;
                    margin-left: 0.5rem;
                }
            }

            @media only screen and (max-width: 600px) {
                text-align: left;
                padding: 0;
            }
        }
    }

    footer {
        border-top: 1px solid $gray-300;
        padding: 2rem 0 0;
        margin-top: 2rem;

        .copyright {
            color: $gray-500 !important;
        }
    }

    .message-count {
        font-size: 0.9rem;
        opacity: 0.8;
    }
</style>
